import { DEBUG } from "@/common/config";
import { decodeJwtToken } from "./AppUtils";
import { logger } from "./logger";

// These functions are kept for compatibility but will log warnings
// since we're now using HTTP-only cookies managed by the server

export const setCookie = (name: string, value: string, expirationInSeconds: number) => {
  // HTTP cookies are set by the server, not by JavaScript
  if (DEBUG) {
    console.log(`[HTTP Cookie] Server will set cookie: ${name}, value: ${value}, expiration: ${expirationInSeconds}`);
  }
};

export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
};

export const isTokenValid = (token: string | null): boolean => {
  if (!token) {
    logger.log("No token provided to validate");
    return false;
  }

  try {
    const decoded = decodeJwtToken(token);
    if (!decoded) {
      logger.log("Token could not be decoded");
      return false;
    }

    // Check if token is expired
    const currentTime = Math.floor(Date.now() / 1000);
    const isValid = decoded.exp > currentTime;

    if (!isValid) {
      logger.log("Token is expired");
    }

    return isValid;
  } catch (error) {
    logger.error("Error validating token:", error);
    return false;
  }
};

export const clearCookie = (name: string) => {
  // HTTP cookies are cleared by the server
  if (DEBUG) {
    console.log(`[HTTP Cookie] Server will clear cookie: ${name}`);
  }
};

export const clearAuthCookies = () => {
  // This will be handled by the logout API call
  if (DEBUG) {
    console.log("[HTTP Cookie] Server will clear auth cookies");
  }
};

export const isUserLoggedIn = (): boolean => {
  const idToken = getCookie("id_token");
  return isTokenValid(idToken);
};
